<template>
	<i v-if="mode" :class="[theme, className, mode]"></i>
	<i v-else :class="className"></i>
</template>
<script>
	import _ from 'lodash'

	export default {
		props: {
			name: { type: String },
			group: { type: String },
			icon: { type: [String, Array] },
			mode: { type: String },
			theme: { type: String },
			options: { type: Object, default: () => ({}) },
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			if (this.params?.options)
				this.settings = _.merge(this.settings, this.params.options)
			if (this.settings.readIconFromOptions)
				this.iconName = this.settings.name
			else
				this.iconName = this.name
		},
		data() {
			return {
				settings: null,
				iconName: '',
			}
		},
		computed: {
			groupName() {
				switch (this.group) {
					case 'solid':
					case 'regular':
					case 'light':
					case 'duo':
						return 'fa' + this.group.substring(0, 1)
					default:
						return 'fas'
				}
			},
			className() {
				if (this.icon) {
					if (Array.isArray(this.icon)) {
						return this.icon.map(x => x.startsWith('fa') ? x : 'fa-' + x).join(' ')
					} else {
						return `${this.groupName} fa-${this.icon}`
					}
				} else {
					return `${this.groupName} fa-${this.iconName}`
				}
			}
		}
	}
</script>

<style></style>
